import { render, staticRenderFns } from "./NewCollectiveModal.vue?vue&type=template&id=1c0b8c58&scoped=true"
import script from "./NewCollectiveModal.vue?vue&type=script&lang=js"
export * from "./NewCollectiveModal.vue?vue&type=script&lang=js"
import style0 from "./NewCollectiveModal.vue?vue&type=style&index=0&id=1c0b8c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0b8c58",
  null
  
)

export default component.exports